import type { Card, DeckId } from '@/core/types'
import type { Deck } from './types'
import { kanaDeck } from './kana'
import { bushuDeck } from './bushu'
import { kanjiDeck } from './kanji'
import { vocabDeck } from './vocab'

export const DECKS: Deck[] = [kanaDeck, bushuDeck, vocabDeck, kanjiDeck]

const byId = new Map<DeckId, Deck>(DECKS.map((d) => [d.id, d]))

export function getDeck(id: DeckId): Deck | undefined {
  return byId.get(id)
}


/**
 * กรองการ์ดตามที่เลือกไว้ในตาราง
 * ไม่ได้เลือกอะไรเลย = เอาทั้งหมด ยกเว้นที่แท็ก rare (ぢ づ ぢゃ ที่แทบไม่เจอในภาษาปัจจุบัน)
 */
export function filterCards(deck: Deck, picked?: Set<string>): Card[] {
  if (picked && picked.size > 0) {
    const list = deck.cards.filter((c) => picked.has(c.id))
    if (list.length > 0) return list
  }
  return deck.cards.filter((c) => !c.tags.includes('rare'))
}

export type { Deck }
export { kanaDeck, bushuDeck, vocabDeck, kanjiDeck }
